export default {"src":"/canvas/_next/static/media/icon-facebook-t5.e061ccd4.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};